import { render, staticRenderFns } from "./ModalWindow.vue?vue&type=template&id=c2af1cf2&scoped=true"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"
import style0 from "./ModalWindow.vue?vue&type=style&index=0&id=c2af1cf2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af1cf2",
  null
  
)

export default component.exports